import { Tabs, TabsList, TabsTrigger } from "@/components/ui/tabs";
import InfoTab from "./InfoTab";
import BusinessHoursTab from "./BusinessHoursTab";
import DialerTab from "./DialerTab";
import NotificationsTab from "./NotificationsTab";

export default function CommunitySettingsPage() {
    return (
        <div className="w-full max-w-7xl mx-auto">
            <h2 className="text-2xl font-bold">Community Settings</h2>
            <p className="text-gray-500">Manage community settings and configurations.</p>

            <Tabs defaultValue="info" className="mt-6">
                <TabsList className="mb-6">
                    <TabsTrigger value="info">Community Information</TabsTrigger>
                    <TabsTrigger value="dialer">Dialer</TabsTrigger>
                    <TabsTrigger value="hours">Business Hours</TabsTrigger>
                    <TabsTrigger value="notifications">Notifications</TabsTrigger>
                </TabsList>

                <InfoTab />

                <BusinessHoursTab />

                <DialerTab />

                <NotificationsTab />
            </Tabs>
        </div>
    );
}
